var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var pymChild = null; 
var gridItems = document.querySelectorAll(".grid-item"); 
var showMore = null; 

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child; 

    // if it's the laptop gfx, always show the grid. else, toggle b/w table/grid on mobile/desktop
    if (document.querySelectorAll(".laptop") != null) {
      shuffleGrid("grid", "grid-item");
      showMore = $.one(".show-more");
    } else if (isMobile.matches) {
      shuffleGrid("table", "table-item"); 
      showMore = $.one(".show-mobile"); 
    } else if (!isMobile.matches) {
      shuffleGrid("grid", "grid-item");
      $.one(".show-more");
    }

    //add show more toggle
    showMore.addEventListener('click', onToggleClicked);

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

var shuffleGrid = function(c, el) {
  var container = document.getElementById(c);
  var elements = Array.prototype.slice.call(container.getElementsByClassName(el));

  // console.log(container, container.getElementsByClassName(el));

  elements.forEach(function(element) {
    container.removeChild(element);
  });

  shuffleData(elements);

  elements.forEach(function(element) {
    container.appendChild(element);
  })
}

var shuffleData = function(array) {
  // shuffle data (from: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array)
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

var onToggleClicked = function() {
  // console.log("CLICK");

  var grid = isMobile.matches ? document.getElementById("table") : $.one(".grid");

  if (document.querySelectorAll(".laptop") != null) {
    grid = $.one(".grid"); 
  }

  console.log(grid)

  if (grid.classList.contains("show-all")) {
    grid.classList.remove("show-all");
    showMore.textContent = showMore.dataset.more;
    pymChild.scrollParentToChildEl("grid");
  } else {
    grid.classList.add("show-all");
    showMore.textContent = showMore.dataset.less;
  }
  if (pymChild) {
    pymChild.sendHeight();
  }
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);